import { useReducer, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import s from './AddNoteModal.scss'
import Select from 'react-select'
import { reducer } from './reducer'
import * as ACT from './actions'
import { TextEditor, FilesUploader } from 'components/ideal-core-ui'
import DatePicker from 'react-datepicker'
import { getDateFormat } from 'utils/authService'
import cn from 'classnames'
import '!style-loader!css-loader!react-datepicker/dist/react-datepicker.css' // eslint-disable-line
import { timezoneDate, utcDate, utcCurrentDate } from 'utils/helpers'
import moment from 'moment'

const initialState = {
  contact: '',
  files: [],
  note: '',
  contacts: [],
  dateEntered: utcCurrentDate()
}

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center'
}

const formatGroupLabel = data => (
  <div style={groupStyles}>
    <span>{data.label}</span>
    <span style={groupBadgeStyles}>{data.options.length}</span>
  </div>
)

const AddNoteModal = ({
  toggleAddNoteModal,
  showAddNoteModal,
  selectedNote = null,
  addNote,
  updateNote,
  groupedContacts
}) => {
  const [state, dispatch] = useReducer(reducer, initialState)

  const removeFile = name => {
    dispatch({
      type: ACT.REMOVE_FILE,
      payload: {
        name
      }
    })
  }

  useEffect(() => {
    if (selectedNote) {
      dispatch({
        type: ACT.SET_SELECTED_NOTE,
        payload: {
          selectedNote
        }
      })
    }
  }, [dispatch, selectedNote])

  const cancelNoteEdit = () => {
    dispatch({
      type: ACT.RESET_FORM,
      payload: {
        initialState
      }
    })
    toggleAddNoteModal(null)
  }
  return (
    <>
      <Modal keyboard={false} backdrop="static" isOpen={showAddNoteModal} size="xl">
        <ModalHeader className={s.modalHeader}>{selectedNote ? 'Edit' : 'Add'} Note</ModalHeader>
        <ModalBody>
          {groupedContacts && (
            <div className={s.pullLeft}>
              <label className={s.label}>Contact</label>
              <Select
                onChange={value => {
                  dispatch({
                    type: ACT.ADD_CONTACT,
                    payload: {
                      contact: value
                    }
                  })
                }}
                options={groupedContacts}
                formatGroupLabel={formatGroupLabel}
                className={s.contactSelect}
                value={state.contact}
                isClearable
              />
            </div>
          )}
          <div className={cn(s.pullLeft, s.dateWrapper)}>
            <label className={s.label}>Created Date</label>
            <DatePicker
              selected={moment(
                timezoneDate(state.dateEntered, 'HH:mm:ss'),
                `${getDateFormat()} HH:mm:ss`
              ).toDate()}
              selectsStart
              startDate={moment(
                timezoneDate(state.dateEntered, 'HH:mm:ss'),
                `${getDateFormat()} HH:mm:ss`
              ).toDate()}
              onChange={value => {
                if (!value) return
                dispatch({
                  type: ACT.ADD_DATE,
                  payload: {
                    dateEntered: utcDate(value)
                  }
                })
              }}
              showTimeSelect
              timeFormat="h:mm aa"
              timeIntervals={15}
              dateFormat={`${getDateFormat().replace('YYYY', 'yyyy').replace('DD', 'dd')} h:mm aa`}
              timeCaption="time"
              placeholderText="Select created date"
              className={s.calendar}
            />
          </div>
          <div className={s.clearfix} />
          <FilesUploader
            files={state.files}
            withLinks
            removeFile={removeFile}
            onDrop={files => {
              dispatch({
                type: ACT.ADD_FILES,
                payload: {
                  files
                }
              })
            }}
          />
          <TextEditor
            template={state.note}
            actions={[
              {
                text: 'Save',
                cb: (template, title, subject, destroyEditor) => {
                  dispatch({
                    type: ACT.ADD_NOTE,
                    payload: {
                      note: template || '--'
                    }
                  })
                  selectedNote
                    ? updateNote(
                        selectedNote.id,
                        toggleAddNoteModal,
                        state.contact?.value || '',
                        state.files,
                        template || '--',
                        state.dateEntered,
                        destroyEditor
                      )
                    : addNote(
                        toggleAddNoteModal,
                        state.contact?.value || '',
                        state.files,
                        template || '--',
                        state.dateEntered,
                        destroyEditor
                      )

                  dispatch({
                    type: ACT.RESET_FORM,
                    payload: {
                      initialState
                    }
                  })
                },
                className: s.saveBtn
              },
              {
                text: 'Cancel',
                cb: (block, title, subject, destroyEditor) => {
                  destroyEditor && destroyEditor()
                  cancelNoteEdit()
                }
              }
            ]}
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default AddNoteModal
